var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalCreationCommande", {
        ref: "modalCreationCommande",
        attrs: { commande: _vm.commandeSelectionnee },
        on: {
          "commande-creee": function($event) {
            return _vm.commandeAjoutee($event)
          }
        }
      }),
      _c("ModalRenommageCommande", {
        ref: "modalRenommageCommande",
        attrs: { commande: _vm.commandeSelectionnee },
        on: {
          "commande-renommee": function($event) {
            return _vm.commandeRenommee()
          }
        }
      }),
      _c("ModalDuplicationCommande", {
        ref: "modalDuplicationCommande",
        attrs: { commande: _vm.commandeSelectionnee },
        on: {
          "commande-dupliquee": function($event) {
            return _vm.commandeDupliquee($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "card table-scroll height-responsive-100" },
            [
              _c(
                "table",
                {
                  staticClass:
                    "table table-bordered table-sm text-center table-header"
                },
                [
                  _vm._m(0),
                  _c("thead", [
                    _c("th", { staticClass: "aligner-gauche" }, [
                      _vm._v("Nom de la commande")
                    ]),
                    _c("th", [_vm._v("Date de création")]),
                    _c("th", [_vm._v("Période de livraisons")]),
                    _c("th", [_vm._v("Période de menus")]),
                    _c("th", [_vm._v("Lignes")]),
                    _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "Nombre de commandes fournisseurs par statut :<br/>à envoyer / envoyés / réceptionnés"
                            },
                            expression:
                              "{ content: 'Nombre de commandes fournisseurs par statut :<br/>à envoyer / envoyés / réceptionnés' }"
                          }
                        ]
                      },
                      [_vm._v("Fournisseurs")]
                    ),
                    _c("th", [_vm._v("Total")])
                  ])
                ]
              ),
              _c("div", { staticClass: "table-body" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-sm text-center" },
                  [
                    _vm._m(1),
                    _c(
                      "tbody",
                      _vm._l(_vm.commandesFiltrees, function(
                        commande,
                        iCommande
                      ) {
                        return _c(
                          "tr",
                          {
                            key: iCommande,
                            class: [
                              {
                                "ligne-selectionnee":
                                  commande.id === _vm.idCommandeSelectionnee
                              },
                              {
                                "ligne-desactivee":
                                  !commande.nbFournisseursEnCreation &&
                                  !commande.nbFournisseursEnvoyes &&
                                  commande.nbFournisseursReceptionnes
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectionnerCommande(commande)
                              }
                            }
                          },
                          [
                            _c(
                              "td",
                              {
                                class: [
                                  "aligner-gauche",
                                  {
                                    "text-success":
                                      !commande.nbFournisseursEnCreation &&
                                      commande.nbFournisseursEnvoyes
                                  }
                                ]
                              },
                              [
                                commande.nbFournisseursEnCreation ||
                                !commande.nbLignes
                                  ? _c("i", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content:
                                              "Commande en cours d'élaboration"
                                          },
                                          expression:
                                            "{ content: 'Commande en cours d\\'élaboration'}"
                                        }
                                      ],
                                      staticClass: "fas fa-shopping-cart"
                                    })
                                  : commande.nbFournisseursEnvoyes
                                  ? _c("i", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content:
                                              "Commande envoyée au fournisseur, en attente de livraison"
                                          },
                                          expression:
                                            "{ content: 'Commande envoyée au fournisseur, en attente de livraison'}"
                                        }
                                      ],
                                      staticClass:
                                        "fas fa-shipping-fast ligne-modifiee"
                                    })
                                  : _c("i", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: "Commande réceptionnée"
                                          },
                                          expression:
                                            "{ content: 'Commande réceptionnée'}"
                                        }
                                      ],
                                      staticClass: "fas fa-boxes ligne-modifiee"
                                    }),
                                _vm._v(" " + _vm._s(commande.nom) + " "),
                                commande.contientErreurMail
                                  ? _c("span", { staticClass: "error ml-2" }, [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-exclamation-triangle"
                                      }),
                                      _vm._v(" Erreur de mail")
                                    ])
                                  : _vm._e(),
                                _vm.commandeEnAttenteDeValidation(commande)
                                  ? _c(
                                      "span",
                                      { staticClass: "text-warning ml-2" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle"
                                        }),
                                        _vm._v(
                                          " En attente de validation par le gestionnaire"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.commandeValidee(commande)
                                  ? _c(
                                      "span",
                                      { staticClass: "text-success ml-2" },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-info-circle"
                                        }),
                                        _vm._v(" Validée par le gestionnaire")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatHumanDateAvecSlashes(
                                    new Date(commande.dateCreation)
                                  )
                                )
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.datesLivraisons(
                                    commande.dateLivraisonDebut,
                                    commande.dateLivraisonFin
                                  )
                                )
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.datesMenus(
                                    commande.dateMenuDebut,
                                    commande.dateMenuFin
                                  )
                                )
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(commande.nbLignes) +
                                  " / " +
                                  _vm._s(commande.nbLignesTotal)
                              )
                            ]),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: {
                                      content:
                                        "A envoyer / Envoyés / Réceptionnés"
                                    },
                                    expression:
                                      "{ content: 'A envoyer / Envoyés / Réceptionnés' }"
                                  }
                                ]
                              },
                              [
                                commande.nbFournisseursEnCreation ||
                                !commande.nbLignes
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass: "fas fa-shopping-cart"
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            commande.nbFournisseursEnCreation
                                          ) +
                                          " / "
                                      )
                                    ])
                                  : _vm._e(),
                                commande.nbFournisseursEnCreation ||
                                !commande.nbLignes ||
                                commande.nbFournisseursEnvoyes
                                  ? _c("span", [
                                      _c(
                                        "span",
                                        { staticClass: "text-success" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-shipping-fast ligne-modifiee"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                commande.nbFournisseursEnvoyes
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" / ")
                                    ])
                                  : _vm._e(),
                                _c(
                                  "span",
                                  { staticClass: "ligne-desactivee" },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-boxes ligne-modifiee"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          commande.nbFournisseursReceptionnes
                                        )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("td", { staticClass: "aligner-droite" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("afficherPrix2")(commande.totalHT)
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "130" } }),
      _c("col", { attrs: { width: "170" } }),
      _c("col", { attrs: { width: "170" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "105" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "130" } }),
      _c("col", { attrs: { width: "170" } }),
      _c("col", { attrs: { width: "170" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "100" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }